import { render, staticRenderFns } from "./IconTextWidget.vue?vue&type=template&id=3efbd168&"
import script from "./IconTextWidget.vue?vue&type=script&lang=js&"
export * from "./IconTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports